import React from 'react';

import { useUnit } from 'effector-react';
import { SnackbarProvider } from 'notistack';

import { modalApi, Modals$ } from '../../effector/modals';
import { MODALS } from '../../utils/types';
import { AccCalcRebalance } from '../Forms/AccCalcRebalance';
import { AccountRebalance, AccountBlock, ServiceStopCS } from '../Forms/AccountManagementAction';
import { ChangePasswordForm } from '../Forms/ChangePassword';
import { ChangePosition } from '../Forms/ChangePosition';
import { CommentForm } from '../Forms/Comment';
import { RemoveDelayedSignal } from '../Forms/RemoveDelayedSignal';
import { RemovePositionForm } from '../Forms/RemovePosition';
import { Modal } from '../Modal';

export const ModalManager: React.FC = ({}) => {
  const modalsState = useUnit(Modals$);

  return (
    <SnackbarProvider maxSnack={3}>
      <Modal
        isOpen={modalsState[MODALS.REMOVE_POSITION]}
        onRequestClose={() => {
          modalApi.hide('');
        }}
        title="Закрытие позиции"
      >
        <RemovePositionForm />
      </Modal>

      <Modal
        isOpen={modalsState[MODALS.CHANGE_PASSWORD]}
        onRequestClose={() => {
          modalApi.hide('');
        }}
        title="Смена пароля"
      >
        <ChangePasswordForm />
      </Modal>

      <Modal
        isOpen={modalsState[MODALS.REMOVE_DELAYED_SIGNAL]}
        onRequestClose={() => {
          modalApi.hide('');
        }}
        title="Закрытие отложенного сигнала"
      >
        <RemoveDelayedSignal />
      </Modal>

      <Modal
        isOpen={modalsState[MODALS.CHANGE_POSITION]}
        onRequestClose={() => {
          modalApi.hide('');
        }}
        title="Замена позиции"
      >
        <ChangePosition />
      </Modal>

      <Modal
        isOpen={modalsState[MODALS.ACCOUNT_REBALANCE]}
        onRequestClose={() => {
          modalApi.hide('');
        }}
        title="Управление аккаунтом"
      >
        <AccountRebalance />
      </Modal>

      <Modal
        isOpen={modalsState[MODALS.ACCOUNT_BLOCK]}
        onRequestClose={() => {
          modalApi.hide('');
        }}
        title="Управление аккаунтом"
      >
        <AccountBlock />
      </Modal>

      <Modal
        isOpen={modalsState[MODALS.ACCOUNT_CALC_REBALANCE]}
        onRequestClose={() => {
          modalApi.hide('');
        }}
        title="Балансировка клиента"
      >
        <AccCalcRebalance />
      </Modal>

      <Modal
        isOpen={modalsState[MODALS.SERVICE_STOP_CS]}
        onRequestClose={() => {
          modalApi.hide('');
        }}
        title="Управление сервисом клиентов"
      >
        <ServiceStopCS />
      </Modal>

      <Modal
        isOpen={modalsState[MODALS.COMMENT]}
        className="modal__min-container"
        onRequestClose={() => {
          modalApi.hide('');
        }}
        title="Обновление комментария"
      >
        <CommentForm />
      </Modal>
    </SnackbarProvider>
  );
};
